export default __webpack_public_path__ + "static/professor-6-fed23b0ff0c295bcd23d08a15b22f467.png";